import { IRootState } from '../../../../store'
import { IChildbirthOBState } from '../store/childbirthOB.types'

export const getChildbirthOBSelector = (state: IRootState): IChildbirthOBState => state.childbirthOB
